import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const PAYOUT_SERVER = ConfigurationService.get(ConfigurationKeys.PAYOUT_SERVER);
const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const PAYOUT_HISTORY = (username) => `${BASE_URL}/rest/v1.0/payout/${username}/requests`;
export const CANCEL_PENDING_REQUEST = (requestId) => `${PAYOUT_SERVER}/rest/v1/requests/cancel/${requestId}`;
export const EWALLET_ACCOUNT_URL = (username) => `${BASE_URL}/rest/v1.0/payment-accounts/${username}`;
export const EARNINGS_DETAILS_URL = (username) => `${BASE_URL}/rest/v1.0/payout/${username}/transaction`;
// eslint-disable-next-line max-len
export const PERFORMER_REVENUE_INSIGHTS = `${BASE_URL}/rest/v1.0/reporting/user/{performerName}/insights?from={startDate}&to={endDate}`;
